import React, { useContext } from 'react'
import { useTheme } from '@emotion/react'
import Container from 'components/container'
import Link from 'components/link'
import Logo from 'components/logo'
import Year from 'components/year'
import Legal from 'components/legal'

export default function Footer({ style, className }){
    const theme = useTheme()
    
    return(
        <footer
            className={className}
            style={style}
        >            
            {/* LINKS */}
            <Container fluid style={{ background: '#f7f7f7' }}>
                <Container
                    className='d-flex'
                    css={{
                        gap: 20,
                        paddingBlock: 64,
                        paddingInline: 120,
                        
                        '& > div': {
                            flex: 1,
                            gap: 20,
                        },

                        '& > a': { minWidth: 'max-content' },

                        [theme.queries.lg]: {
                            paddingBlock: 48,
                            paddingInline: 32,
                        },

                        [theme.queries.sm]: {
                            flexDirection: 'column',
                            gap: 40,
                            paddingInline: 16,
                        },
                        
                        [theme.queries.xs]: {
                            '& > div': { flexBasis: 0 },
                        },
                    }}
                >
                    {/* Our brands */}
                    <div className='d-flex col'>
                        <p><strong>Our Brands</strong></p>
                        <Link href='https://native-instruments.com' arrow={false}>
                            Native Instruments
                        </Link>
                        <Link href='https://akaipro.com' arrow={false}>
                            AKAI Professional
                        </Link>
                        <Link href='https://moogmusic.com' arrow={false}>
                            Moog
                        </Link>
                        <Link href='https://rane.com' arrow={false}>
                            Rane
                        </Link>
                        <Link href='https://alesisdrums.com' arrow={false}>
                            Alesis Drums
                        </Link>
                        <Link href='https://numark.com' arrow={false}>
                            Numark
                        </Link>
                        <Link href='https://m-audio.com' arrow={false}>
                            M-Audio
                        </Link>
                        <Link href='https://headrushfx.com' arrow={false}>
                            Headrush
                        </Link>
                    </div>

                    <div className='d-flex col'>
                        <p style={{ visibility: 'hidden' }} css={{
                            [theme.queries.sm]: {
                                // height of this element, minus gap between columns, minus gap between column's elements
                                marginBottom: -16.67 - 20 -  20,
                            }
                        }}>
                            <strong>Our Brands</strong>
                        </p>
                        <Link href='https://airmusictech.com' arrow={false}>
                            AIR
                        </Link>
                        <Link href='https://alesis.com' arrow={false}>
                            Alesis
                        </Link>
                        <Link href='https://denondj.com' arrow={false}>
                            Denon DJ
                        </Link>
                        <Link href='https://bfddrums.com' arrow={false}>
                            BFD
                        </Link>
                        <Link href='https://enginedj.com' arrow={false}>
                            Engine DJ
                        </Link>
                        <Link href='https://altoprofessional.com' arrow={false}>
                            Alto Professional
                        </Link>
                        <Link href='https://ionaudio.com' arrow={false}>
                            ION
                        </Link>
                        <Link href='https://soundswitch.com' arrow={false}>
                            SoundSwitch
                        </Link>
                    </div>

                    {/* Company */}
                    <div className='d-flex col'>
                        <p><strong>Company</strong></p>
                        <Link to='/about'>
                            About Us
                        </Link>
                        <Link to='/dealers'>
                            Dealers
                        </Link>
                    </div>
                    
                    {/* Support */}
                    <div className='d-flex col'>
                        <p><strong>Support</strong></p>
                        <Link href='https://inmusicbrands.pinpointhq.com' arrow={false}>
                            Careers
                        </Link>
                        <Link href='https://support.inmusicstore.com/en/support/home' arrow={false}>
                            Contact Us
                        </Link>
                        <Link href='https://profile.inmusicbrands.com' arrow={false}>
                            inMusic Profile
                        </Link>
                    </div>
                </Container>
            </Container>

            {/* INMUSIC / LEGAL */}
            <Container fluid style={{ background: '#ddd' }}>
                <Container
                    className='d-flex col'
                    style={{ gap: 48, paddingBlock: 40 }}
                    css={{                        
                        paddingInline: 120,
                        [theme.queries.lg]: { paddingInline: 32 },
                        [theme.queries.sm]: { paddingInline: 16 },
                    }}
                >
                    {/* Logo and line */}
                    <div
                        className='d-flex a-center'
                        style={{ gap: 24 }}
                    >
                        <Logo black />
                        <div style={{ flex: 1, height: 1, transform: 'scaleY(.5)', background: 'black' }} />
                    </div>
                    <Legal />
                </Container>
            </Container>
        </footer>
    )
}
